import React from "react";
import "../styles/BottomMenu.css";
import { useAuth } from "../context/AuthContext";
import inicioIcon from "../assets/ic_book.png";
import planIcon from "../assets/ic_calendar.png";
import frankitoIcon from "../assets/ic_frankito.png";
import rankingIcon from "../assets/ic_podium2.png";
import controlIcon from "../assets/ic_teacher.png";
import LogOutIcon from "../assets/ic_logout.png";


function BottomMenu({ isModalOpen }) {
  const { logout } = useAuth();
  //console.log("isModalOpen:", isModalOpen);

  const handleLogout = async () => {
    try {
      await logout();   // 👈 función del AuthContext
      // opcional: redirigir al login
      window.location.href = "/login";
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  return (
    <nav className={`bottom-menu ${isModalOpen ? "menu-hidden" : ""}`}>
      <ul>
        <li>
          <img src={inicioIcon} alt="Inicio" className="menu-icon" />
          <span className="menu-label">Inicio</span>
        </li>
        <li>
          <img src={planIcon} alt="Plan" className="menu-icon" />
          <span className="menu-label">Plan de estudios</span>
        </li>
        <li>
          <img src={frankitoIcon} alt="Frankito" className="menu-icon" />
          <span className="menu-label">Frankito</span>
        </li>
        <li>
          <img src={rankingIcon} alt="Ranking" className="menu-icon" />
          <span className="menu-label">Ranking</span>
        </li>
        <li>
          <img src={controlIcon} alt="Control" className="menu-icon" />
          <span className="menu-label">Control</span>
        </li>
        <li>
          <img src={LogOutIcon} alt="Logout" className="menu-icon" />
          <span className="menu-label" onClick={handleLogout}>Cerrar sesión</span>
        </li>
      </ul>
    </nav>
  );
}

export default BottomMenu;
